export default __webpack_public_path__ + "static/media/colibriDeVientreBlanco.a04a5f6c.jpg";